import React, { Component } from 'react';
import { connect } from 'react-redux';
import {SortableContainer, SortableElement } from 'react-sortable-hoc';

import LayerItem from './LayerItem';

import { sortLayer, deselectObjects } from "../actions";

const SortableItem = SortableElement(({value}) => {
  return <LayerItem data={value} />
});

const SortableList = SortableContainer(({indexes, objects}) => {
  if (indexes.length === 0) {
    return (
      <div className="t-component-layers-empty">デザイン要素が追加されていません</div>
    );
  }

  return (
    <div>
      {indexes.slice().reverse().map((value, i) => {
        return <SortableItem key={i} index={i} value={objects[value]} />
      })}
    </div>
  );
});

class Layers extends Component {
  constructor(props) {
    super(props);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.onSortStart = this.onSortStart.bind(this);
  }

  onSortEnd({oldIndex, newIndex}) {
    this.props.sortLayer(oldIndex, newIndex);
  }

  onSortStart() {
    this.props.deselectObjects();
  }

  render() {
    let className = 't-component-layers';

    if (this.props.layers.show) {
      className += ' open';
    }

    return (
      <div className={className}>
        <div className="t-component-layers-title">
          レイヤー一覧
        </div>
        <SortableList lockAxis="y" useDragHandle={true} lockToContainerEdges={true} indexes={this.props.index} objects={this.props.objects} onSortEnd={this.onSortEnd} onSortStart={this.onSortStart} />
      </div>
    );

    // return (
    //   <div className={className}>
    //     {this.props.index.map(id => {
    //       return <LayerItem key={id} data={this.props.objects[id]} />;
    //     })}
    //   </div>
    // );
  }
}

export default connect(f => {
  return {
    objects: f.objects.present.objects[f.objects.present.currentSurface.surface.id],
    index: f.objects.present.index[f.objects.present.currentSurface.surface.id],
    layers: f.layers
  }
}, {sortLayer, deselectObjects})(Layers);



// WEBPACK FOOTER //
// ./src/components/Layers.js